/**
 * Small, vanilla-shaped sample files so the editor is usable before anyone
 * uploads their own mission folder. Coordinates are Chernarus+.
 */
export type SampleFile = { fileName: string; content: string };

const DECL = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>';

export const SAMPLE_FILES: SampleFile[] = [
  {
    fileName: 'bear_territories.xml',
    content: `${DECL}
<territories>
\t<territory color="0xFF8E24AA">
\t\t<zone name="BearNorthWest" smin="0" smax="1" dmin="1" dmax="2" x="2100.0" z="12500.0" r="600.0" />
\t\t<zone name="BearBlackMountain" smin="0" smax="1" dmin="1" dmax="2" x="4550.0" z="9100.0" r="520.0" />
\t</territory>
\t<territory color="0xFF6D4C41">
\t\t<zone name="BearEastForest" smin="0" smax="1" dmin="1" dmax="3" x="12250.0" z="10400.0" r="700.0" />
\t</territory>
</territories>
`,
  },
  {
    fileName: 'wolf_territories.xml',
    content: `${DECL}
<territories>
\t<territory color="0xFF1E88E5">
\t\t<zone name="WolfNorthRoad" smin="2" smax="4" dmin="2" dmax="5" x="7400.0" z="11800.0" r="800.0" />
\t\t<zone name="WolfKabanino" smin="2" smax="3" dmin="2" dmax="4" x="5650.0" z="8300.0" r="650.0" />
\t\t<zone name="WolfSouthWoods" smin="1" smax="3" dmin="1" dmax="4" x="9100.0" z="4200.0" r="750.0" />
\t</territory>
</territories>
`,
  },
  {
    fileName: 'cfgeventspawns.xml',
    content: `${DECL}
<eventposdef>
\t<event name="StaticHeliCrash">
\t\t<pos x="4200.0" z="9800.0" a="0.0" />
\t\t<pos x="7650.0" z="7300.0" a="45.0" />
\t\t<pos x="11200.0" z="12400.0" a="120.0" />
\t</event>
\t<event name="StaticContaminatedArea">
\t\t<pos x="10500.0" z="3400.0" a="0.0" />
\t</event>
\t<event name="VehicleCivilianSedan">
\t\t<pos x="6350.0" z="2700.0" a="180.0" />
\t\t<pos x="8900.0" z="5900.0" a="90.0" />
\t</event>
</eventposdef>
`,
  },
  {
    fileName: 'events.xml',
    content: `${DECL}
<events>
\t<event name="StaticHeliCrash">
\t\t<nominal>4</nominal>
\t\t<min>2</min>
\t\t<max>6</max>
\t\t<lifetime>1800</lifetime>
\t\t<restock>0</restock>
\t\t<saferadius>500</saferadius>
\t\t<distanceradius>500</distanceradius>
\t\t<cleanupradius>200</cleanupradius>
\t\t<flags deletable="0" init_random="0" remove_damaged="1" />
\t\t<position>fixed</position>
\t\t<limit>mixed</limit>
\t\t<active>1</active>
\t\t<children>
\t\t\t<child lootmax="0" lootmin="0" max="1" min="1" type="Wreck_Mi8" />
\t\t</children>
\t</event>
\t<event name="VehicleCivilianSedan">
\t\t<nominal>10</nominal>
\t\t<min>5</min>
\t\t<max>12</max>
\t\t<lifetime>1800</lifetime>
\t\t<restock>0</restock>
\t\t<saferadius>500</saferadius>
\t\t<distanceradius>500</distanceradius>
\t\t<cleanupradius>200</cleanupradius>
\t\t<flags deletable="0" init_random="0" remove_damaged="1" />
\t\t<position>fixed</position>
\t\t<limit>mixed</limit>
\t\t<active>1</active>
\t\t<children>
\t\t\t<child lootmax="0" lootmin="0" max="1" min="1" type="CivilianSedan" />
\t\t</children>
\t</event>
</events>
`,
  },
  {
    fileName: 'types.xml',
    content: `${DECL}
<types>
\t<type name="AKM">
\t\t<nominal>12</nominal>
\t\t<lifetime>7200</lifetime>
\t\t<restock>0</restock>
\t\t<min>6</min>
\t\t<quantmin>-1</quantmin>
\t\t<quantmax>-1</quantmax>
\t\t<cost>100</cost>
\t\t<flags count_in_cargo="0" count_in_hoarder="0" count_in_map="1" count_in_player="0" crafted="0" deloot="0" />
\t\t<category name="weapons" />
\t\t<usage name="Military" />
\t\t<value name="Tier3" />
\t\t<value name="Tier4" />
\t</type>
\t<type name="TacticalBaconCan">
\t\t<nominal>40</nominal>
\t\t<lifetime>14400</lifetime>
\t\t<restock>0</restock>
\t\t<min>25</min>
\t\t<quantmin>-1</quantmin>
\t\t<quantmax>-1</quantmax>
\t\t<cost>100</cost>
\t\t<flags count_in_cargo="0" count_in_hoarder="0" count_in_map="1" count_in_player="0" crafted="0" deloot="0" />
\t\t<category name="food" />
\t\t<usage name="Military" />
\t\t<usage name="Police" />
\t\t<value name="Tier2" />
\t</type>
\t<type name="FirefighterAxe">
\t\t<nominal>8</nominal>
\t\t<lifetime>14400</lifetime>
\t\t<restock>0</restock>
\t\t<min>4</min>
\t\t<quantmin>-1</quantmin>
\t\t<quantmax>-1</quantmax>
\t\t<cost>100</cost>
\t\t<flags count_in_cargo="0" count_in_hoarder="0" count_in_map="1" count_in_player="0" crafted="0" deloot="0" />
\t\t<category name="tools" />
\t\t<usage name="Industrial" />
\t\t<usage name="Firefighter" />
\t\t<value name="Tier1" />
\t\t<value name="Tier2" />
\t</type>
</types>
`,
  },
];

/** Vanilla usage / tier / category tags, used by the loot economy panel. */
export const USAGE_TAGS = [
  'Military', 'Police', 'Medic', 'Firefighter', 'Industrial', 'Farm', 'Coast',
  'Town', 'Village', 'Hunting', 'Office', 'School', 'Prison', 'Lunapark', 'SeasonalEvent',
  'ContaminatedArea', 'Historical',
];

export const VALUE_TAGS = ['Tier1', 'Tier2', 'Tier3', 'Tier4', 'Unique'];

export const CATEGORY_TAGS = [
  'weapons', 'tools', 'containers', 'clothes', 'food', 'books', 'explosives', 'lootdispatch',
];

/** Loot container tags: restrict an item to shelf or floor loot points. */
export const CONTAINER_TAGS = ['floor', 'shelves', 'ground'];
